import React, { forwardRef } from 'react';

import * as Styles from './ContentSection.styles';
import {
  IconInfo,
} from 'gatorcomponents';
import { Tooltip } from '@/pages/common/v1/Tooltip';

const ContentSection = forwardRef(({
  title,
  tooltip,
  children,
  direction = 'column',
  align = 'flex-start',
  justify = 'flex-start',
  minWidth,
  flex,
  testId,
}, ref) => (
  <Styles.ContentSection ref={ref} $direction={direction} $align={align} $justify={justify} $minWidth={minWidth} $flex={flex} data-testid={testId}>
    {title && (
      <Styles.Header>
        {title && <Styles.Title>{title}</Styles.Title>}
        {tooltip && <Tooltip content={tooltip} preferredPosition="right"><IconInfo color="lowDark" /></Tooltip>}
      </Styles.Header>
    )}
    {children}
  </Styles.ContentSection>
));

export default ContentSection;
